import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ViewComponent } from "./view.component";

import { MatTabsModule } from "@angular/material/tabs";
import { PageLayoutModule } from "../../../../../@vex/components/page-layout/page-layout.module";
import { MatInputModule } from "@angular/material/input";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatChipsModule } from "@angular/material/chips";
import { MatSelectModule } from "@angular/material/select";
import { MatButtonModule } from "@angular/material/button";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatDividerModule} from '@angular/material/divider';
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule } from "@angular-material-components/datetime-picker";
import { MatDatepicker, MatDatepickerModule } from "@angular/material/datepicker";
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSlideToggleModule } from "@angular/material/slide-toggle";


@NgModule({
    declarations: [ViewComponent],
    imports: [
        CommonModule,
        PageLayoutModule,
        MatTabsModule,
        MatInputModule,
        FlexLayoutModule,
        MatChipsModule,
        MatSelectModule,
        MatButtonModule,
        FormsModule,
        ReactiveFormsModule,
        MatSnackBarModule,
        MatProgressBarModule,
        MatDividerModule,
        MatCardModule,
        MatIconModule,
        NgxMatDatetimePickerModule,
        MatDatepickerModule,
        MatAutocompleteModule,
        MatSlideToggleModule
    ],
})
export class ViewModule {}
